import React, { useMemo } from 'react';
import InputMoney from '../InputMoney';
import { EditavelContainer, ViewModeText, EditModeContainer, ErrorMessage } from '../EditavelCommon/styles';
import { applyMoneyMask } from '../../../utils/masks';

interface MoneyInputEditavelProps {
    value: string | number | undefined;
    onChange: (value: string) => void;
    isEditing: boolean;
    label?: string;
    required?: boolean;
    error?: string;
    disabled?: boolean;
    onBlur?: () => void;
}

const MoneyInputEditavel: React.FC<MoneyInputEditavelProps> = ({
    value,
    onChange,
    isEditing,
    label,
    required = false,
    error,
    disabled = false,
    onBlur,
}) => {
    const formatValueForDisplay = useMemo(() => {
        if (value === undefined || value === null || value === '') return 'R$ 0,00';
        return applyMoneyMask(value);
    }, [value]);

    const handleChange = (numericValue: string) => {
        onChange(numericValue);
    };

    // Se estiver desabilitado, sempre mostra modo visualização
    if (disabled || !isEditing) {
        return (
            <EditavelContainer>
                <ViewModeText>
                    {formatValueForDisplay}
                </ViewModeText>
                {error && <ErrorMessage>{error}</ErrorMessage>}
            </EditavelContainer>
        );
    }

    return (
        <EditavelContainer>
            <EditModeContainer>
                <InputMoney
                    value={value || '0'}
                    onChangeText={handleChange}
                    onBlur={onBlur}
                    disabled={disabled}
                    title={label}
                    error={error}
                />
            </EditModeContainer>
        </EditavelContainer>
    );
};

export default MoneyInputEditavel;

